import { SettingsSidebar } from '@/features/settings/components';
import { Page, PageHeader } from '@/shared/ui/page';
import { Home } from 'lucide-react';
import { ReactNode } from 'react';

type SettingsLayoutProps = {
  children: ReactNode;
};

const breadcrumbItems = [
  {
    label: 'Página Inicial',
    href: '/dashboard',
    iconLeft: <Home className='h-4 w-4' />,
  },
  { label: 'Configurações', active: true },
];

export function SettingsLayout({ children }: SettingsLayoutProps) {
  return (
    <Page.Root>
      <Page.Breadcrumb items={breadcrumbItems} />

      <div className='flex flex-col w-full h-full'>
        <div className='flex-shrink-0'>
          <PageHeader.Root>
            <PageHeader.Main>
              <PageHeader.TitleGroup>
                <PageHeader.Title>Configurações</PageHeader.Title>
                <PageHeader.Subtitle>
                  Gerencie todas as configurações do sistema
                </PageHeader.Subtitle>
              </PageHeader.TitleGroup>
            </PageHeader.Main>
          </PageHeader.Root>
        </div>

        <div className='flex flex-col gap-4 w-full flex-1 min-h-0 mt-6 lg:flex-row lg:gap-6'>
          <SettingsSidebar />
          <div className='flex-1 min-w-0'>{children}</div>
        </div>
      </div>
    </Page.Root>
  );
}
